module.exports = __webpack_public_path__ + "img/overview-active.a0337dd7.svg";